// extracted by mini-css-extract-plugin
export default {"healthoverview":"DogCardHealthOverview_healthoverview__5qpB3","healthtable":"DogCardHealthOverview_healthtable__8O1i3"};